import { createFileRoute, redirect } from '@tanstack/react-router'

import { cachedCan } from '@/features/auth/session'
import { EditVehicle } from '@/features/vehicles/edit-vehicle'

// `$vehicleId_`: a sibling of the detail route, not a child rendered inside it.
export const Route = createFileRoute('/_app/vehicles/$vehicleId_/edit')({
  // `_app` has already put the profile in the cache and selected a dealership: a member who
  // cannot change stock is sent to the vehicle before the form ever renders.
  beforeLoad: ({ context, params }) => {
    if (!cachedCan(context.queryClient, 'sell')) {
      throw redirect({
        to: '/vehicles/$vehicleId',
        params: { vehicleId: params.vehicleId },
        replace: true,
      })
    }
  },
  component: EditVehicle,
})
